import { createReducer } from 'redux-act';
import { AuthMethod } from 'config/constants';
import { updateFetchBookingAuthProcess, updateAuthMethod, setAuthToSSO, setIsSSOLoginScreenVisible, setAuthToOAuth } from './actions';
import { initialState as sbaAuthInitialState, reducerBranches as sbaReducerBranches } from './sba/reducer';
import { initialState as ssoAuthInitialState, reducerBranches as ssoReducerBranches } from './sso/reducer';
import { initialState as oAuthInitialState, reducerBranches as oAuthReducerBranches } from './oauth/reducer';

const initialState = {
  hasFetchedBookingAuthMethod: false,
  isSSOLoginScreenVisible: false,
  authMethod: null,
  sbaUser: sbaAuthInitialState,
  ssoUser: ssoAuthInitialState,
  oAuthUser: oAuthInitialState,
};

const authenticationReducer = createReducer(
  {
    [updateFetchBookingAuthProcess]: (state, payload) => ({
      ...state,
      hasFetchedBookingAuthMethod: !!payload.done,
    }),
    [updateAuthMethod]: (state, payload) => ({
      ...state,
      authMethod: payload.authMethod,
    }),
    [setAuthToSSO]: (state) => ({
      ...state,
      authMethod: AuthMethod.WIDGET,
      hasFetchedBookingAuthMethod: true,
    }),
    [setAuthToOAuth]: (state) => ({
      ...state,
      authMethod: AuthMethod.OAUTH,
      hasFetchedBookingAuthMethod: true,
    }),
    [setIsSSOLoginScreenVisible]: (state, payload) => ({
      ...state,
      isSSOLoginScreenVisible: payload,
    }),
    ...sbaReducerBranches,
    ...ssoReducerBranches,
    ...oAuthReducerBranches,
  },
  initialState,
);

export default authenticationReducer;
